



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import GeneralLedgerAccountState from "@/models/Accounting/GeneralLedgerAccounts/GeneralLedgerAccountState";

@Component({ name: 'GeneralLedgerAccountState', })
export default class extends SaascadaVue {

    @Prop({ required: true })
    state: GeneralLedgerAccountState;

    get textColor() {
        var color: string = "grey--text";
        switch (this.state) {
            case GeneralLedgerAccountState.Active:
                color = "success--text";
                break;
            case GeneralLedgerAccountState.Deleted:
                color = "error--text";
                break;
        }
        return color;
    }

}
